// extracted by mini-css-extract-plugin
export var optionGrid = "_87-7";
export var optionList = "_87-6";
export var questionsBlock = "_87-9";
export var spacer = "_87-5";
export var stepCenteredContent = "_87-3";
export var stepInner = "_87-0";
export var stepInnerFullWidth = "_87-1";
export var stepInnerLockScroll = "_87-2";
export var stepTransitionFrame = "_87-4";
export var welcomeBlock = "_87-8";